export default __webpack_public_path__ + "static/media/10-new.ae356e40.png";